import { Component, Element, Prop, h, Host } from '@stencil/core';

/** Display a spinner to indicate a loading state. */
@Component({
  tag: 'pn-spinner',
  styleUrl: 'pn-spinner.scss',
})
export class PnSpinner {
  @Element() hostElement: HTMLElement;

  /** Light version of the spinner. */
  @Prop() light: boolean = false;
  /** Size in em. */
  @Prop() size: number = 1.5;

  private getColor() {
    if (this.light) return '#fff';
    return '#005d92';
  }

  private getSize() {
    return `${this.size}em`;
  }

  render() {
    return (
      <Host>
        <svg
          class="pn-spinner"
          style={{ '--pn-spinner-size': this.getSize(), '--pn-spinner-color': this.getColor() }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle class="pn-spinner-circle" cx="12" cy="12" r="10" stroke-width="3" />
          <circle class="pn-spinner-dot" cx="21.3" cy="16" r="1.48" />
        </svg>
      </Host>
    );
  }
}
